module.exports = __webpack_public_path__ + "static/img/cover.48f5c8c8.jpg";